import { useParams } from "react-router-dom";

/**
 * Gets the current booking ID from url parameter
 * @returns The booking ID or null if not found
 */
export const useBookingId = () => {
    const { bookingId } = useParams();
    return bookingId ?? null;
};
